import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var _d2874a18 = function _d2874a18() {
  return import('../pages/_page.vue' /* webpackChunkName: "pages/_page" */).then(function (m) {
    return m.default || m;
  });
};
var _e463abfc = function _e463abfc() {
  return import('../pages/_page/_inner.vue' /* webpackChunkName: "pages/_page/_inner" */).then(function (m) {
    return m.default || m;
  });
};
var _0692a6a3 = function _0692a6a3() {
  return import('../pages/_page/_inner/_einner.vue' /* webpackChunkName: "pages/_page/_inner/_einner" */).then(function (m) {
    return m.default || m;
  });
};

var scrollBehavior = function scrollBehavior(to, from) {
  var pages = ['catalog', 'news', 'materials', 'recipes'],
      props = ['vacancy', 'join', 'docs'],
      data = { x: 0, y: 0 };

  props.forEach(function (el) {
    if (from.query[el] !== undefined || to.query[el] !== undefined) {
      data = from;
    }
  });

  pages.forEach(function (el) {
    if (from.params.page === el && to.params.page === el && !to.params.inner) {
      data = from;
    }
  });

  return data;
};

export function createRouter() {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'link--active',
    linkExactActiveClass: 'link--active-exact',
    scrollBehavior: scrollBehavior,
    routes: [{
      path: "/:page?",
      component: _d2874a18,
      name: "page",
      children: [{
        path: ":inner?",
        component: _e463abfc,
        name: "page-inner",
        children: [{
          path: ":einner?",
          component: _0692a6a3,
          name: "page-inner-einner"
        }]
      }]
    }],

    fallback: false
  });
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/router.js
// module id = ./.nuxt/router.js
// module chunks = 5